var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-player',{ref:"videoPlayer",attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"play":function($event){},"pause":function($event){}}})}
var staticRenderFns = []

export { render, staticRenderFns }